import { TocItem } from "../../Types/UserManual.type";

export const pdfBasePath = '/assets/pdf/acers_product_user_manual_document.pdf';

export const tableOfContents: TocItem[] = [
    { title: '1. Introduction', page: 3, section: 'introduction', isMainSection: true },
    { title: '2. System Access', page: 3, section: 'system-access', isMainSection: true },
    { title: '3. Settings', page: 4, section: 'settings', isMainSection: true },
    { title: '3.1 Create Groups', page: 4, section: 'create-groups' },
    { title: '3.2 Create Users', page: 5, section: 'create-users' },
    { title: '4. Reference Data', page: 8, section: 'reference-data', isMainSection: true },
    { title: '4.1 Broker', page: 9, section: 'broker' },
    { title: '4.2 Clearer', page: 9, section: 'clearer' },
    { title: '4.3 Books', page: 10, section: 'books' },
    { title: '4.4 Strategy', page: 11, section: 'strategy' },
    { title: '4.5 Derivative', page: 12, section: 'derivative' },
    { title: '4.6 Holiday', page: 13, section: 'holiday' },
    { title: '4.7 Contract Type', page: 14, section: 'contract-type' },
    { title: '4.8 Units', page: 14, section: 'units' },
    { title: '4.9 Contract', page: 15, section: 'contract' },
    { title: '4.10 Counterparty Companies', page: 16, section: 'counterparty-companies' },
    { title: '4.11 Clearer Rates', page: 17, section: 'clearer-rates' },
    { title: '4.12 Brokerage', page: 18, section: 'brokerage' },
    { title: '4.13 API Settings', page: 19, section: 'api-settings' },
    { title: '4.14 API Broker Settings', page: 20, section: 'api-broker-settings' },
    { title: '4.15 Clearing Account', page: 20, section: 'clearing-account' },
    { title: '4.16 Futures LTD', page: 21, section: 'futures-ltd' },
    { title: '5. Trade Capture', page: 22, section: 'trade-capture', isMainSection: true },
    { title: '5.1 Trade Capture Manual', page: 22, section: 'trade-capture-manual' },
    { title: '5.2 Exchange Trades', page: 24, section: 'exchange-trades' },
    { title: '5.3 Deal Blotter', page: 29, section: 'deal-blotter' },
    { title: '5.3.1 Organization Trades', page: 29, section: 'organization-trades' },
    { title: '5.3.2 Counterparty Trades', page: 29, section: 'counterparty-trades' },
    { title: '5.3.3 Open Trades', page: 31, section: 'open-trades' },     
    { title: '5.3.4 Closed Trades', page: 31, section: 'closed-trades' },  
    { title: '5.4 Trade Confirmation', page: 31, section: 'trade-confirmation' },
    { title: '6. Settlement Prices', page: 33, section: 'settlement-prices', isMainSection: true },
    { title: '7. Position & Risk', page: 36, section: 'position-risk', isMainSection: true },
    { title: '7.1 Position', page: 36, section: 'position' },
    { title: '7.2 Daily Exposure', page: 42, section: 'daily-exposure' },
    { title: '7.3 P&L', page: 43, section: 'pnl' },
    { title: '7.4 Initial Margin', page: 44, section: 'initial-margin' },
    { title: '8. Profit Share % Split', page: 45, section: 'profit-share', isMainSection: true },
    { title: '9. Customer Markup Matrix', page: 47, section: 'customer-markup-matrix', isMainSection: true },
    { title: '10. Display Markup, Optimisation & Statement Price', page: 48, section: 'display-markup', isMainSection: true },
];

export const modalHeaderStyle: React.CSSProperties = {
    background: '#ffffff',
    color: '#1a1f36',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '18px 24px',
    borderBottom: '1px solid #e5e7eb',
};


export const headerContentStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
};


export const modalBodyStyle: React.CSSProperties = {
    padding: 0,
    maxHeight: '70vh',
    overflowY: 'auto',
};

export const tocListStyle: React.CSSProperties = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
};    

export const tocItemContentStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};
